import { useState } from "react";
import API from "@src/API.js";
import AutoComplete from "../Controls/AutoComplete";

export default function CertificationSearch(props) {
  const [certifications, updateCerts] = useState([]);
  const formObject = props.formObject?.object || props.object || {};
  const displayName = props.value || formObject.Name || formObject.name || "";

  async function onChangeAsync(newValue) {
    if (!newValue || newValue.length < 2) return;
    const resp = await API.getAsync("/Certification/Search?Term=" + encodeURIComponent(newValue));
    if (resp && resp.ok && Array.isArray(resp.jsonData)) {
      updateCerts(
        resp.jsonData.map((e) => ({
          ...e,
          ID: e.CertificationID ?? e.certificationID ?? e.ID ?? e.id,
          CertificationID: e.CertificationID ?? e.certificationID ?? e.ID ?? e.id,
          Name: e.Name ?? e.name,
          ShortName: e.ShortName ?? e.shortName,
          OrganizationName: e.OrganizationName ?? e.organizationName ?? e.OrgName,
          OrganizationID: e.OrganizationID ?? e.organizationID,
        }))
      );
    } else {
      console.error("Unable to retrieve certifications");
    }
  }

  function onSelect(value) {
    if (!value) return;
    const name = typeof value === "string" ? value : value.Name || value.name;
    const emp =
      typeof value === "object"
        ? value
        : certifications.find((em) => em.Name === name || em.ShortName === name);
    if (!emp) return;

    const certificationId = emp.CertificationID ?? emp.ID ?? emp.id;
    if (props.onChange) {
      props.onChange(emp, props.field || props.label || "Name");
    } else if (props.formObject?.onChange) {
      props.formObject.onChange(name, "Name");
      props.formObject.onChange(certificationId, "CertificationID");
      props.formObject.onChange(emp.ShortName || "", "ShortName");
      props.formObject.onChange(emp.OrganizationName || "", "OrganizationName");
      props.formObject.onChange(emp.OrganizationID || 0, "OrganizationID");
    } else if (props.onSelect) {
      props.onSelect(emp);
    }
  }

  return (
    <div className="field EmployerSearch">
      <label>{props.label || "Name"}</label>
      <AutoComplete
        freeSolo
        autoComplete
        value={displayName}
        options={certifications.map((e) => e.Name)}
        onInputChange={(e, value) => onChangeAsync(value)}
        onChange={(e, value) => onSelect(value)}
        renderInput={(params) => <input type="text" {...params} />}
      />
    </div>
  );
}
